import { render, staticRenderFns } from "./AssignLeads.vue?vue&type=template&id=605301d7&"
import script from "./AssignLeads.vue?vue&type=script&lang=js&"
export * from "./AssignLeads.vue?vue&type=script&lang=js&"
import style0 from "./AssignLeads.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports